import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

function PrivacyEn() {
  return (
    <>
      <p>Camper Solar Monitor ("the App") is developed and provided by Kai Steuernagel ("we", "us", "our"). This Privacy Policy explains what data the App processes — and, in short, why there is almost nothing to explain: the App does not collect any data.</p>

      <h2>1. Data Controller</h2>
      <div className="privacy-contact-card">
        <p><strong>Kai Steuernagel</strong></p>
        <p>Email: <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a></p>
        <p>Website: <a href="https://www.steuernagel.net">www.steuernagel.net</a></p>
      </div>

      <h2>2. No Data Collection</h2>
      <p>The App is designed to work entirely offline. We do not collect, store, transmit, sell, or analyze any personal data, because the App has no backend and no internet connectivity to do so. Specifically:</p>
      <ul>
        <li>No account, registration, or sign-in is required or offered.</li>
        <li>No personal data is transmitted to us or to any third party.</li>
        <li>No analytics, crash reporting, advertising, or tracking SDKs are integrated.</li>
        <li>No internet connection is required or used by the App at any point.</li>
        <li>No location data is requested or accessed.</li>
      </ul>

      <h2>3. Bluetooth Usage</h2>
      <p>The App uses Bluetooth Low Energy (BLE) exclusively to communicate directly and locally with your own monitoring hardware (e.g., a battery monitor, a Victron solar charge controller, or a starter battery monitor) while it is in Bluetooth range of your device.</p>
      <p>This communication happens solely between your device and your hardware. There is no server in between — we do not operate one, and the App does not connect to one. iOS will request Bluetooth permission the first time you launch the App or attempt to pair a device; this permission is used only to enable the local connection described above.</p>

      <h2>4. Data Stored on Your Device</h2>
      <p>Settings you configure — such as which device you last paired, your light/dark mode preference, or the "keep screen awake" option — are stored locally on your device only, using standard iOS storage mechanisms. This data never leaves your device, is never transmitted anywhere, and is not accessible to us.</p>

      <h2>5. Third Parties</h2>
      <p>The App does not share data with third parties, since no data is collected in the first place. The App is an independent monitoring display and is not affiliated with, endorsed by, or otherwise connected to ECO-Worthy, Victron Energy, JBD, Daly, intAct, or any other hardware manufacturer mentioned in the App's description.</p>

      <h2>6. Children's Privacy</h2>
      <p>The App does not knowingly collect data from anyone, including children, because it does not collect personal data from any user regardless of age.</p>

      <h2>7. Changes to This Policy</h2>
      <p>We may update this Privacy Policy occasionally, for example to reflect changes to the App's functionality. Any changes will be posted on this page with an updated "Last updated" date above.</p>

      <h2>8. Contact</h2>
      <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a>.</p>
    </>
  );
}

function PrivacyDe() {
  return (
    <>
      <p>Camper Solar Monitor ("die App") wird von Kai Steuernagel ("wir", "uns") entwickelt und bereitgestellt. Diese Datenschutzerklärung erläutert, welche Daten die App verarbeitet – und, kurz gesagt, warum es dazu kaum etwas zu erklären gibt: Die App sammelt keinerlei Daten.</p>

      <h2>1. Verantwortlicher</h2>
      <div className="privacy-contact-card">
        <p><strong>Kai Steuernagel</strong></p>
        <p>E-Mail: <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a></p>
        <p>Webseite: <a href="https://www.steuernagel.net">www.steuernagel.net</a></p>
      </div>

      <h2>2. Keine Datenerhebung</h2>
      <p>Die App wurde so konzipiert, dass sie vollständig offline funktioniert. Wir sammeln, speichern, übertragen, verkaufen oder analysieren keine personenbezogenen Daten, da die App weder über ein Backend noch über eine Internetverbindung verfügt, um dies zu tun. Im Einzelnen:</p>
      <ul>
        <li>Es ist kein Konto, keine Registrierung und keine Anmeldung erforderlich oder verfügbar.</li>
        <li>Es werden keine personenbezogenen Daten an uns oder Dritte übertragen.</li>
        <li>Es sind keine Analyse-, Absturzbericht-, Werbe- oder Tracking-SDKs integriert.</li>
        <li>Die App benötigt und nutzt zu keinem Zeitpunkt eine Internetverbindung.</li>
        <li>Es werden keine Standortdaten angefragt oder abgerufen.</li>
      </ul>

      <h2>3. Bluetooth-Nutzung</h2>
      <p>Die App verwendet Bluetooth Low Energy (BLE) ausschließlich, um direkt und lokal mit deiner eigenen Überwachungs-Hardware zu kommunizieren (z.&nbsp;B. einem Batteriemonitor, einem Victron-Solarladeregler oder einem Starterbatterie-Monitor), solange sich diese in Bluetooth-Reichweite deines Geräts befindet.</p>
      <p>Diese Kommunikation findet ausschließlich zwischen deinem Gerät und deiner Hardware statt. Es gibt keinen Server dazwischen – wir betreiben keinen, und die App verbindet sich mit keinem. iOS fragt beim ersten Start der App bzw. beim Versuch, ein Gerät zu koppeln, die Bluetooth-Berechtigung ab; diese wird ausschließlich für die oben beschriebene lokale Verbindung verwendet.</p>

      <h2>4. Auf deinem Gerät gespeicherte Daten</h2>
      <p>Einstellungen, die du vornimmst – etwa welches Gerät zuletzt gekoppelt war, deine Präferenz für helles/dunkles Design oder die Option „Bildschirm an lassen" – werden ausschließlich lokal auf deinem Gerät gespeichert, unter Verwendung der Standard-Speichermechanismen von iOS. Diese Daten verlassen niemals dein Gerät, werden nirgendwohin übertragen und sind für uns nicht einsehbar.</p>

      <h2>5. Weitergabe an Dritte</h2>
      <p>Die App gibt keine Daten an Dritte weiter, da von vornherein keine Daten erhoben werden. Die App ist eine unabhängige Anzeige-App und steht in keiner geschäftlichen Verbindung zu ECO-Worthy, Victron Energy, JBD, Daly, intAct oder anderen in der App-Beschreibung genannten Herstellern.</p>

      <h2>6. Datenschutz für Kinder</h2>
      <p>Die App sammelt wissentlich keine Daten von Nutzern, einschließlich Kindern, da sie unabhängig vom Alter der Nutzer keinerlei personenbezogene Daten erhebt.</p>

      <h2>7. Änderungen dieser Erklärung</h2>
      <p>Wir können diese Datenschutzerklärung gelegentlich aktualisieren, etwa um Änderungen an der Funktionalität der App widerzuspiegeln. Änderungen werden auf dieser Seite mit aktualisiertem Datum veröffentlicht.</p>

      <h2>8. Kontakt</h2>
      <p>Bei Fragen zu dieser Datenschutzerklärung kontaktiere uns bitte unter <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a>.</p>
    </>
  );
}

function PrivacyCamperSolarMonitor() {
  const { lang } = useLang();
  const isDE = lang === "de";

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">
          <Link to="/camper-solar-monitor-app" className="back-link">← Camper Solar Monitor App</Link>
        </span>
        <div className="subhead">{isDE ? "Datenschutzerklärung" : "Privacy Policy"}</div>
        <p className="section-intro-inner privacy-meta">
          Camper Solar Monitor · {isDE ? "Stand: 13. Juli 2026" : "Last updated: July 13, 2026"}
        </p>
      </div>

      <div className="privacy-content">
        {isDE ? <PrivacyDe /> : <PrivacyEn />}
        <p className="privacy-footer">© Kai Steuernagel — Camper Solar Monitor</p>
      </div>
    </div>
  );
}

export default PrivacyCamperSolarMonitor;
